module.exports = __webpack_public_path__ + "static/media/Hoboken5.eec9ef3e.jpg";